import { useQuery } from '@tanstack/react-query'

import { QUERY_KEYS } from 'constants/constants'
import { EVALUATION_CONTEXT } from '../features/discover/utils'
import { query } from '../graphql'

export const useMatchingProfileQuery = (
  spaceId,
  userId,
  careerId,
  language,
  matching,
  options = {}
) => {
  return useQuery({
    queryKey: QUERY_KEYS.matchingProfile(
      spaceId,
      userId,
      careerId,
      language,
      matching
    ),
    queryFn: async () => {
      const variables = {
        action: 'generateText',
        space_id: spaceId,
        user_id: userId,
        career_id: careerId,
        language,
        text_generation_context: EVALUATION_CONTEXT.MATCHINGPROFILE,
        matching: JSON.stringify(matching)
      }

      const response = await query({
        query: 'helperControl',
        variables
      })

      if (!response || response === 'undefined') {
        console.error(
          'useMatchingProfileQuery: Invalid response received:',
          response
        )
        throw new Error('Invalid response from helperControl query')
      }

      try {
        const parsed = JSON.parse(response)
        if (!parsed?.body?.generateText?.res) {
          console.error(
            'useMatchingProfileQuery: Invalid response structure:',
            parsed
          )
          throw new Error('Invalid response structure from helperControl')
        }
        return parsed.body.generateText.res
      } catch (error) {
        console.error(
          'useMatchingProfileQuery: JSON parse error:',
          error,
          'Response:',
          response
        )
        throw new Error(
          `Failed to parse matching profile response: ${error.message}`
        )
      }
    },
    enabled: !!(spaceId && userId && careerId && language && matching),
    ...options
  })
}
